import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, DatePicker, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { updateSession } from '../../../redux/Session/actions';
import { fetchFreeMachines } from '../../../redux/Machine/actions';
import EditMachineButton from '../Machines/EditMachineButton';

const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const EditSessionsButton = ({ item, users }) => {
  const events = useSelector(state => state.events.data);
  const freeMachines = useSelector(state => state.machines?.machines || []);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [initialFetched, setInitialFetched] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null); // State for selected machine

  useEffect(() => {
    if (visible && !initialFetched) {
      dispatch(fetchFreeMachines());
      setInitialFetched(true);
    }
  }, [visible, dispatch, initialFetched]);

  const showModal = () => {
    onFill();
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedMachine(null); // Reset selected machine on cancel
  };

  const onFill = () => {
    if (item) {
      const { sessionname, event, startDate, endDate, machine } = item;

      // Convert dates to moment objects
      const startDateMoment = startDate ? moment(startDate) : null;
      const endDateMoment = endDate ? moment(endDate) : null;

      form.setFieldsValue({
        sessionname: sessionname || '',
        event: event?._id || '',
        startDate: startDateMoment,
        endDate: endDateMoment,
        machine: machine?._id || '', // Ensure machine ID is used
      });

      setSelectedMachine(machine); // Set the selected machine
    }
  };

  const handleEventChange = (eventId) => {
    const selectedEvent = events.find(event => event._id === eventId);
    if (selectedEvent) {
      form.setFieldsValue({
        startDate: moment(selectedEvent.dateAndTime.startDateTime),
        endDate: moment(selectedEvent.dateAndTime.endDateTime),
      });
    }
  };

  const handleMachineChange = (machineId) => {
    const machine = freeMachines.find(machine => machine._id === machineId);
    setSelectedMachine(machine); // Update selected machine state
  };

  const form_onFinish = async (values) => {
    const updatedSession = {
      sessionname: values.sessionname,
      startDate: values.startDate?.toISOString(),
      endDate: values.endDate?.toISOString(),
      event: values.event,
      machine: values.machine,
    };

    await dispatch(updateSession(item._id, updatedSession));
    setVisible(false);
    setInitialFetched(false);
  };

  return (
    <>
      <a onClick={showModal}>
        Modifier
      </a>
      <Modal
        title="Modifier Session"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
      >
        <Form
          {...layout}
          form={form}
          onFinish={form_onFinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="Event"
            name="event"
            rules={[{ required: true, message: 'Please select an event!' }]}
          >
            <Select onChange={handleEventChange}>
              {events.map((event) => (
                <Option key={event._id} value={event._id}>
                  {event.eventname}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Session Name"
            name="sessionname"
            rules={[
              { required: true, message: 'Please input the session name!' },
              { min: 3, message: 'Session name must be at least 3 characters long' },
              { max: 100, message: 'Session name must be less than 100 characters long' }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: 'Please select a start date!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
            />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: 'Please select an end date!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
            />
          </Form.Item>

          <Form.Item
            label="Machine"
            name="machine"
            rules={[{ required: true, message: 'Please select a machine!' }]}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                onChange={handleMachineChange}
                value={selectedMachine?.machinename} // Display machine name instead of ID
                style={{ flex: 1, marginRight: 8 }} // Ensure the Select takes full width
              >
                {freeMachines.map((machine) => (
                  <Option key={machine._id} value={machine._id}>
                    {machine.machinename}
                  </Option>
                ))}
              </Select>
              {selectedMachine && (
                <EditMachineButton item={selectedMachine} users={users} /> // Pass the users prop
              )}
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditSessionsButton;
